import {PriceModel} from '../Price.model';
import {PriceSummary as PriceSummaryV1} from '@wix/auto_sdk_ecom_current-cart';
import {V2PriceSummary as PriceSummary} from '@wix/auto_sdk_ecom_cart-v-2';
import {ModelContext} from '../../../types/app.types';

export class PriceSummaryModel {
  public subtotal: PriceModel;
  public delivery: PriceModel;
  public tax: PriceModel;
  public discount: PriceModel;
  public total: PriceModel;
  public additionalFees: PriceModel;

  constructor(params: PriceSummaryModel) {
    this.subtotal = params.subtotal;
    this.delivery = params.delivery;
    this.tax = params.tax;
    this.discount = params.discount;
    this.total = params.total;
    this.additionalFees = params.additionalFees;
  }

  public static fromCartV1(priceSummary: PriceSummaryV1, modelContext: ModelContext) {
    return new PriceSummaryModel({
      subtotal: PriceModel.fromCartV1(priceSummary.subtotal, modelContext),
      total: PriceModel.fromCartV1(priceSummary.total, modelContext),
      tax: PriceModel.fromCartV1(priceSummary.tax, modelContext),
      discount: PriceModel.fromCartV1(priceSummary.discount, modelContext),
      additionalFees: PriceModel.fromCartV1(priceSummary.additionalFees, modelContext),
      delivery: PriceModel.fromCartV1(priceSummary.shipping, modelContext),
    });
  }

  public static fromCartV2(priceSummary: PriceSummary, modelContext: ModelContext): PriceSummaryModel {
    return new PriceSummaryModel({
      subtotal: PriceModel.fromCartV2(priceSummary.subtotal, modelContext),
      total: PriceModel.fromCartV2(priceSummary.total, modelContext),
      tax: PriceModel.fromCartV2(priceSummary.tax, modelContext),
      discount: PriceModel.fromCartV2(priceSummary.discount, modelContext),
      additionalFees: PriceModel.fromCartV2(priceSummary.additionalFees, modelContext),
      delivery: PriceModel.fromCartV2(priceSummary.delivery, modelContext),
    });
  }
}
